import OptionalImage from '@src/components/optional-image';
import React from 'react';
import { observer } from 'mobx-react';
// import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';

// import cs from 'classnames';

import styles from './index.less';

const SuccessModal = ({ store, onClose }) => {
  store.use(onClose);

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.content}>
        <div onClick={store.onSuccessModalClose} className={styles.close_btn} data-name="关闭" />
        <div className={styles.qrcode_box}>
          {!store.loading ? (
            <OptionalImage onClick={store.getQrcode} className={styles.qrcode_img} src={store.qrcodeImg} alt="二维码" />
          ) : (
            <img className={styles.loading_img} src={require('../images/loading.gif')} alt="loading" />
          )}
        </div>
      </div>
    </ModalContainer>
  );
};

export default observer(SuccessModal);
